import React, { Component } from "react";
import '../Configuration.css';
import { Box, Paper, TextField, Button, Stack, Typography, Grid, Autocomplete, FormControlLabel, Checkbox, } from "@mui/material";
import { DataGrid } from '@mui/x-data-grid';
import { withTranslation } from 'react-i18next';
import CommonGridHeader, { CommonDeleteButton, CommonEditButton, DeletePopup } from "../../../Components/Common Components/CommonComponents";
import { Colors } from "../../../Styles/Colors";
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import RestAPIService from "../../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import { CheckAccessFunc } from "../../../Components/CommonFunctions/CommonFunctions";
import { ImagePaths } from "../../../Utility/ImagePaths";

class VitalConfigration extends Component {
    constructor(props) {
        super(props);
        this.state = {
            vital_layout_data: [],
            specDetails: [],
            data: [],
            deleteId: null,
            srcspecialization_name: "",
            id: null,
            specialization: "",
            data: [],
            selectedItem: {},
            editIndex: -1,
            deletedPopup: false,
            isEdit: false,
            page: 0,
            pageSize: 10,
            showSuccessResponse: false,
            showErrorResponse: false,
            right_Fields_data: [],
            drag_label: null,
            layout_id: null,
            specialization_id: null,
            default_right_Fields_data: [],
        }
    }

    componentDidMount() {
        this.getVitalData()
        this._getSpecializationDetails()
    }

    LoaderFunction = (key) => {
        this.setState({
            isLoader: key
        })
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }
    _getSpecializationDetails = () => {
        this.setState({
            specDetails: [],

        })
        try {
            this.LoaderFunction(true)
            RestAPIService.getAll(Serviceurls.FO_CONFIG_OPSPECIALIZATION)
                .then(response => {
                    if (response.data.status === "success") {
                        this.setState({
                            specDetails: response.data.data ? response?.data?.data : [],
                        }, () => {
                            this.state.specDetails?.push({ "name": "Common" })
                            this.state.specDetails?.forEach((item, i) => {
                                item.index = i
                            })
                            this.LoaderFunction(false)
                        });
                    }
                })
                .catch(error => {
                    this.LoaderFunction(false)
                    if (error?.response?.data?.status === "fail") {
                        this.errorMessage(error?.response?.data?.message);
                    }
                });
        } catch (e) {
            this.LoaderFunction(false)
            this.errorMessage(e?.message);
        }
    }


    getDeepCopy = (data) => {
        return JSON.parse(JSON.stringify(data))
    }
    getVitalData = () => {
        try {
            this.LoaderFunction(true)
            RestAPIService.getAll(Serviceurls.VITALS_CONFIGURATION)
                .then((response) => {
                    if (response.data.status === "success") {
                        let commonLayoutData = null;
                        const layOutData = response.data.data?.map((item, index) => {
                            const updatedItem = {
                                ...item,
                                sno: index + 1,
                                ...(item.is_common && { specialization_name: "Common" })
                            };
                            if (item.is_common && !commonLayoutData) commonLayoutData = this.getDeepCopy(updatedItem);
                            return updatedItem;
                        });
                        const deepCopiedData = commonLayoutData ? this.getDeepCopy(commonLayoutData?.vital_layout_data) : [];
                        this.setState({
                            layOutData: layOutData,
                            right_Fields_data: deepCopiedData,
                            default_right_Fields_data: deepCopiedData,
                        }, () => {
                            this.LoaderFunction(false)
                        })
                    }
                }).catch((error) => {
                    this.LoaderFunction(false)
                    if (error?.response?.data?.message) {
                        this.errorMessage(error?.response?.data?.message)
                    } else {
                        this.errorMessage(error?.message)
                    }
                })

        } catch (e) {
            this.LoaderFunction(false)
            this.errorMessage(e?.message)
        }
    }
    successMessage = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message
        })
    }
    postVitalData = () => {
        try {
            let states = this.state

            let data = {
                specialization_id: states.specialization_id ? states.specialization_id : null,
                field_order: states.right_Fields_data
            }
            if (this.state.isEdit) {
                data["id"] = states.onClickEditId;
                data["is_common"] = states.specialization?.name === "Common";
            }
            let vitalActivedData = states.right_Fields_data.some((item) => item.is_active)
            if (vitalActivedData === false) {
                this.errorMessage("Select atleast one vital data")
            } else {
                RestAPIService.create(data, Serviceurls.VITALS_CONFIGURATION)
                    .then((response) => {
                        if (response.data.status === 'success') {
                            this.successMessage(response?.data?.message)
                            this.getVitalData()
                            this.setState({
                                specialization: null,
                                isEdit: false,
                                right_Fields_data: this.getDeepCopy(this.state.default_right_Fields_data),
                            })
                        }
                    }).catch((error) => {
                        if (error?.response?.data?.message) {
                            this.errorMessage(error?.response?.data?.message)
                        } else {
                            this.errorMessage(error?.message)
                        }
                    })
            }
        } catch (e) {
            this.errorMessage(e?.message)
        }
    }

    responseSuccessErrorMessage(message, type) {
        this.setState({
            showSuccessResponse: message ? type : false,
            showErrorResponse: message ? !type : false,
            responseMessage: message
        })
    }



    handleDelete = (value) => {
        if (!this.state.isEdit) {
            this.setState({
                deletedPopup: true,
                deleteId: value?.id ? value?.id : null,
                srcspecialization_name: value?.specialization_name
            })
        }
    }

    PopupClose = () => {
        this.setState({
            deletedPopup: false,
            deleteId: null,
            srcspecialization_name: ""
        })
    }

    removeDataList = () => {
        try {
            RestAPIService.delete(`${Serviceurls.VITALS_CONFIGURATION}?id=${this.state.deleteId ? this.state.deleteId : 0}`)
                .then(response => {
                    if (response.data.status === "success") {
                        this.setState({
                            deletedPopup: false,
                            deleteId: null,
                            srcspecialization_name: ""
                        }, () => {
                            this.responseSuccessErrorMessage(response?.data?.message, true);
                            this.getVitalData();
                        })
                    }
                })
                .catch(error => {
                    if (error?.response?.data?.status === "fail") {
                        this.responseSuccessErrorMessage(error?.response?.data?.message, false);
                    }
                });
        } catch (e) {
            this.responseSuccessErrorMessage(e?.message, false);
        }
    }



    handleClear = () => {
        let states = this.state;
        states["specialization_name"] = "";
        states["description"] = "";
        states["selectedItem"] = {};
        states["data"] = [];
        states["id"] = null;
        states["isEdit"] = false;
        states["editIndex"] = -1;
        this.setState({
            states
        })
    }

    msgClose() {
        this.setState({
            showSuccessResponse: false,
            showErrorResponse: false,
            responseMessage: ''
        })
    }


    OnClickEditHandler = (item) => {
        try {
            const matchingSpecialization = this.state.specDetails.find(
                spec => spec.name === (item.is_common ? "Common" : item?.specialization_name)
            )
            this.setState({
                onClickEditId: item?.id,
                isEdit: true,
                right_Fields_data: item?.vital_layout_data ? this.getDeepCopy(item?.vital_layout_data) : [],
                specialization: matchingSpecialization || null,
                specialization_id: item?.specialization_id || null
            })
        } catch (error) {
            this.responseSuccessErrorMessage(error?.message, false)
        }
    }
    handleDrag = (e) => {
        this.setState({
            drag_label: e.currentTarget.id
        })
    }

    handleDrop = (e) => {
        var states = this.state
        const dragBox = (states.right_Fields_data).find((field) => field.label === states.drag_label);
        const dropBox = (states.right_Fields_data).find((field) => field.label === e.currentTarget.id);

        const dragBoxID = dragBox.id;
        const dropBoxID = dropBox.id;

        const dragBoxField = dragBox.field_name;
        const dropBoxField = dropBox.field_name;

        const dragBoxCheck = dragBox.is_active;
        const dropBoxCheck = dropBox.is_active;

        // To make the default field also draggable.
        const dragBoxDefault = dragBox.is_default;
        const dropBoxDefault = dropBox.is_default;

        const newBoxState = (states.right_Fields_data).map((field) => {
            if ((!dragBoxDefault && !dropBoxDefault) || (dragBoxDefault && dropBoxDefault)) {
                if (field.label === states.drag_label) {
                    field.id = dropBoxID;
                    field.field_name = dragBoxField;
                    field.is_active = dragBoxCheck;
                    field.is_default = dragBoxDefault;
                }
                if (field.label === e.currentTarget.id) {
                    field.id = dragBoxID;
                    field.field_name = dropBoxField;
                    field.is_active = dropBoxCheck;
                    field.is_default = dropBoxDefault;
                }
            }
            else if (dropBoxID <= +this.state.mandotory_count && dragBoxID <= +this.state.mandotory_count) {
                if (field.label === states.drag_label) {
                    field.id = dropBoxID;
                    field.field_name = dragBoxField;
                    field.is_active = dragBoxCheck;
                    field.is_default = dragBoxDefault;
                }
                if (field.label === e.currentTarget.id) {
                    field.id = dragBoxID;
                    field.field_name = dropBoxField;
                    field.is_active = dropBoxCheck;
                    field.is_default = dropBoxDefault;
                }
            } else if (!(dropBoxID <= +this.state.mandotory_count && dragBoxID <= +this.state.mandotory_count)) {
                this.errorMessage("Default Mandatory Fields are only dragable Within Mandatory Counts")
            }

            return field;
        });

        const SortData = newBoxState.sort((a, b) => { return a.id - b.id })

        this.setState({
            right_Fields_data: SortData
        })
    }

    handleCheckClick = (e) => {
        var { right_Fields_data } = this.state

        const ID = e.target.id
        const Index = right_Fields_data?.findIndex((data) => {
            return data.id == ID
        })
        if (Index === -1) return;
        if (right_Fields_data[Index].is_default) {

        } else {
            right_Fields_data[Index].is_active = e.target.checked
        }

        if (e.target.name === 'spo2' && !e.target.checked) {
            const oxygenIndex = right_Fields_data?.findIndex(field => field.field_name === 'oxygensource');
            if (oxygenIndex !== -1) {
                right_Fields_data[oxygenIndex].is_active = false;
            }
        }
        this.setState({
            right_Fields_data
        })
    }
    renderRightField = (data) => {
        const isSPO2Active = this.state.right_Fields_data?.find(field => field.field_name === 'spo2')?.is_active;

        // Disable Oxygen Source checkbox if SPO2 is not active
        const isOxygenSource = data.field_name === 'oxygensource';
        const shouldDisable = isOxygenSource && !isSPO2Active;

        return (
            <div
                // To make the default field also draggable.
                // draggable={data.is_default ? false : true}
                draggable={true}
                onDragOver={(e) => e.preventDefault()}
                onDragStart={this.handleDrag}
                onDrop={this.handleDrop}
                id={data.label}
                className="eMed_demolayout_right2_field">
                <img className="eMed_demolayout_right2_field_img" src={ImagePaths.DragIndicator.default} alt="" />
                <FormControlLabel control={<Checkbox name={data.field_name}
                    disabled={shouldDisable} id={data?.id}
                    onChange={this.handleCheckClick} checked={data.is_active} />}
                    label={data.is_default ? (data.label + "*") : data.label} />
            </div>
        )
    }

    renderDemoLayoutRight = () => {
        try {
            const { t } = this.props
            var states = this.state

            return (
                <Stack component={"div"}>

                    <Paper elevation={2} sx={{ mt: "0vh", height: "68vh", width: "30vw", backgroundColor: "white", overflowY: "scroll" }}>
                        <Typography className='eMed_refdoc_title'>{t("Vitals Layout")}</Typography>
                        <Box className='emed_demolayout_right1_box'  >
                            <Autocomplete
                                disableClearable
                                disabled={this.state.specialization?.name === "Common"}
                                value={this.state.specialization}
                                sx={{ width: "20vw", marginLeft: "0.5vw" }}
                                size="small"
                                options={this.state.specDetails}
                                getOptionLabel={option => typeof (option) === "string" ? option : option?.name}
                                onChange={(event, newValue) => {
                                    if (newValue){

                                        this.setState({
                                            specialization: newValue?.name,
                                            specialization_id: newValue?.id
                                        })

                                    }

                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label={t("Specialization name")}
                                        InputProps={{
                                            ...params.InputProps
                                        }}
                                    />
                                )}
                            />
                        </Box>
                        <Typography className='eMed_refdoc_title' sx={{ margin: "0.8vh" }} >{"Select Vitals To Continue"}</Typography>
                        {(states.right_Fields_data)
                            // .sort((a, b) => a.id - b.id)
                            .map((item, index) => {
                                return (
                                    this.renderRightField(item)
                                )
                            })}
                    </Paper>
                    <Paper className='eMed_demolayout_right3' elevation={2}>
                        <Button variant='outlined' size="small" id="eMed_Config_btn" sx={{ mr: '0.5vw' }} onClick={() => {
                            this.setState({
                                layout_id: null,
                                specialization: null,
                                right_Fields_data: this.getDeepCopy(this.state.default_right_Fields_data),
                                isEdit: false,
                            })
                        }}>{t("Reset")}</Button>
                        <Button disabled={(!CheckAccessFunc("front_office", "Settings", "Layout Configuration", "Vital Configuration", "SubTab")?.editAccess) || (!this.state.specialization)} variant='contained' size="small" id="eMed_Config_btn" sx={{ ml: '0.5vw' }} onClick={() => { this.postVitalData() }}>{t("SAVE")}</Button>
                    </Paper>

                </Stack>
            )
        } catch (e) {
            this.errorMessage(e)
        }
    }

    render() {
        const { t } = this.props;
        let { layOutData } = this.state;
        const columns = [
            { field: 'sno', headerName: 'S.No', flex: 0.08 },
            {
                field: 'specialization_name', headerName: t('Specialization'), flex: 0.70, renderCell: (params) => {
                    return (<div>{params?.row?.specialization_name ? params?.row?.specialization_name : "-"}</div>)
                }
            },
            {
                field: 'actions', headerAlign: 'center', headerName: t('Action'), flex: 0.22, sortable: false, hideable: false, align: "center", renderCell: (params) => {
                    return (
                        <Stack direction="row" alignItems="center" spacing={4}>
                            <Stack direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
                                <CommonEditButton disabled={!CheckAccessFunc("front_office", "Settings", "Layout Configuration", "Vital Configuration", "SubTab")?.editAccess} size="1.5vw" onClick={this.OnClickEditHandler.bind(this, params.row)} />
                                {!params.row.is_common   && <CommonDeleteButton disabled={(!CheckAccessFunc("front_office", "Settings", "Layout Configuration", "Vital Configuration", "SubTab")?.editAccess) && (this.state.isEdit)} disable = {this.state.isEdit} size="1.5vw" onClick={this.handleDelete.bind(this, params.row)} />
                                }                          
                            </Stack>
                        </Stack>
                    )
                }
            }
        ]
        return (
            <Box id="eMed_srvConfig_Container" sx={{ backgroundColor: Colors.configHomeBg }}>
                <Grid container spacing={3} className="eMed_srvConfig_Box">
                    <Grid item xs={7.6}>
                        <Paper className="eMed_srvConfig_Div" >
                            <DataGrid
                                rows={layOutData ? layOutData : []}
                                columns={columns}
                                getRowId={(row) => row['sno']}
                                localeText={{
                                    toolbarColumns: "",
                                    toolbarDensity: "",
                                    toolbarExport: "",
                                    toolbarFilters: "",
                                    toolbarExportPrint: ""
                                }}
                                headerHeight={40}
                                disableSelectionOnClick
                                components={{
                                    Toolbar: CommonGridHeader.CommonToolBar,
                                    NoRowsOverlay: () => {
                                        return (
                                            <Stack direction="row" justifyContent="center" alignItems="center" sx={{ height: "53vh" }}>
                                                {t("NoRecordsFound")}
                                            </Stack>
                                        )
                                    }
                                }}
                                rowCount={layOutData?.length}
                                page={this.state.page}
                                onPageChange={(newPage) => { this.setState({ page: newPage }) }}
                                pageSize={this.state.pageSize}
                                onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
                                rowsPerPageOptions={[10, 20, 30]}
                                pagination
                                loading={this.state.isLoader}
                            />
                        </Paper>
                    </Grid>
                    <Grid item xs={4.4}>
                        {this.renderDemoLayoutRight()}
                    </Grid>
                </Grid>
                {this.state.deletedPopup ?
                    <DeletePopup DeletTitle={`${t("deleteMsg")}  ${this.state.srcspecialization_name ? this.state.srcspecialization_name : "-"} ?`}
                        DeleteNotify={t("effectEntireSetting")}
                        deleteAlertPopupClose={this.PopupClose.bind(this)}
                        removeData={this.removeDataList.bind(this)}
                    />
                    : null}
                {this.state.showSuccessResponse ? <ToastMsg severity={"success"} msg={this.state.responseMessage} msgPop={this.msgClose.bind(this)} /> : null}
                {this.state.showErrorResponse ? <ToastMsg severity={"error"} msg={this.state.responseMessage} msgPop={this.msgClose.bind(this)} /> : null}
                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                {this.state.successMsg ?
                    <ToastMsg
                        severity={'success'}
                        msg={this.state.successMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
            </Box>
        )
    }
}
export default withTranslation()(VitalConfigration);
